// MUI-free copy of Ui-components/questions (MUI-Components/MUI-Accordian SimpleAccordion → the AccordionItem atom's
// `bordered` skin). Answers stay in the server HTML: collapsed panels are hidden, not unmounted, as with MUI's Accordion.
import {memo} from 'react';
import AccordionItemView from '@/components/atoms/AccordionItem';
import type {AccordionItem} from '@/types';
import {useOpenItem} from '@/hooks/useOpenItem';
import {cx} from '@/util/cx';
import styles from './Questions.module.scss';

export interface QuestionsProps {
    accordianData?: AccordionItem[];
}

const Questions = ({accordianData}: QuestionsProps) => {
    const [expanded, handleToggle] = useOpenItem();

    return (
        <div>
            <h2 className={cx('font-headers', styles.heading)}>Frequently Asked Questions</h2>
            <div>
                <div className={cx('faq-inner-wrapper', styles.wrapper)}>
                    <div className={styles.grid}>
                        {accordianData?.map((data, index) => (
                            <div key={index} className={cx('accordion-grid-main', styles.item)}>
                                <AccordionItemView
                                    variant="bordered"
                                    id={`panel${index}a-header`}
                                    question={data.question}
                                    answer={data.answer}
                                    expanded={expanded === index}
                                    onToggle={() => handleToggle(index)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Questions);
